<section class="fc-master-card uitk-c-card">
  <div class="d-flex fc-master-details p-2 m-0">
    <div class="flex-item">
      <label>{{ dataSource?.app_id }}</label>
      <p class="Value ">{{ dataSource?.app_name }}</p>
    </div>
    <div class="flex-item">
      <label>Service Name</label>
      <p class="Value d-flex align-center ">
        <span
          class="int-label-txt me-1"
          [hidden]="!(masterData?.I_Flag == 'Yes')"
          matTooltipPosition="above"
          matTooltip="Build Under International Rate"
          >INT</span
        >{{ dataSource?.SV_Desc }}
      </p>
    </div>
    <div class="flex-item">
      <label>Rate {{ currentYear - 1 }}/UOM {{ currentYear - 1 }}</label>
      @if (PY_Rate_Unit.CY_Rate) {
      <p class="Value">${{ PY_Rate_Unit?.CY_Rate }}/{{ PY_Rate_Unit.Unit_Of_Measure }}</p>
      } @if (!PY_Rate_Unit.CY_Rate) {
      <p class="Value">NA</p>
      }
    </div>
    <div class="flex-item">
      <label>Rate {{ currentYear }}/UOM {{ currentYear }}</label>
      @if (CY_Rate_Unit.CY_Rate) {
      <p class="Value">${{ CY_Rate_Unit?.CY_Rate }}/{{ CY_Rate_Unit.Unit_Of_Measure }}</p>
      } @if (!CY_Rate_Unit.CY_Rate) {
      <p class="Value">NA</p>
      }
    </div>
    <div class="flex-item">
      <label>Rate {{ currentYear + 1 }}/UOM {{ currentYear + 1 }}</label>
      @if (FY_Rate_Unit.CY_Rate) {
      <p class="Value">${{ FY_Rate_Unit?.CY_Rate }}/{{ FY_Rate_Unit.Unit_Of_Measure }}</p>
      } @if (!FY_Rate_Unit.CY_Rate) {
      <p class="Value">NA</p>
      }
    </div>
  </div>
  @if (dataSource?.UI_Comments) {
  <div class="d-flex fc-master-comment-details p-2 m-0">
    <div class="flex-item-comment">
      <i class="stk-title uitk-icon uitk-icon-info_hollow p-0 health excelandinfo-Icon-font"></i>
      <p class="comment-text">{{ dataSource?.UI_Comments }}</p>
    </div>
  </div>
  }
</section>
